import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 50772 45480"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#2b2a29;stroke-width:562.648}.fil0{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974598852976">
        <path
          d="M23551 23516c-828 193-815 636-815 1629-292-78-942-589-1304-834-2042-1383-4389-3178-6392-4499l-2570-1809c-1907-1410-4469-3051-6342-4447-456-340-832-676-1510-679-1766-7-3973 2347-4312 4301-58 339-25 810 211 1175 117 182 145 193 290 321l15943 10319c397 249 967 732 1405 835 559-1055 1236-1783 2427-2257 2859-1137 8591-1374 10986 855 381 355 898 863 1042 1402 421-98 944-539 1356-782l9271-5998c1259-841 6740-4101 7086-4825 628-1316-657-3005-1339-3751l-199-209c-15-14-38-35-53-48-116-110-154-136-266-243-1054-1005-2341-1538-3657-549L28727 24723c-240 180-376 336-698 422 0-1338-7-1249-916-1730V6924c-553-266-3243-639-3512 254-154 512-50 15427-50 16338zM5024 41941c0 1675 1818 3258 3461 3258 735 0 1284-525 1790-858 310-202 506-299 816-506l3278-2118c744-476 7101-4494 7349-4866-363-97-957-522-1281-754-1043-754-2470-2215-2587-3624-380 90-1307 813-1672 1078-568 413-1057 716-1614 1134l-9033 6338c-216 171-507 533-507 918z"
          className="fill stroke1"
          style={{
            strokeWidth: 562.648,
          }}
        />
        <path
          d="M19938 31593c0 1531 643 2328 1955 3237 789 549 2471 1350 3410 1350 1250 0 2818-789 3585-1348 503-365 904-691 1324-1186 1181-1390 913-3445-1013-4392-2289-1126-9261-1224-9261 2339zM29047 36851c209 312 1086 792 1548 1100 3171 2116 6685 4240 9833 6352 735 492 1074 896 2056 896 1789 0 4313-2820 2807-4130l-7346-5176c-677-468-4649-3330-5029-3420-39 1704-2718 4110-3869 4378zM21616 2725c0 1374 937 2018 1221 2442 1564-365 2601-634 4279-203 555 142 652 283 1041-69 1776-1600 1215-4614-2469-4614-1437 0-2862 76-3684 1304-124 183-388 897-388 1140z"
          className="fill stroke1"
          style={{
            strokeWidth: 562.648,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
